/* eslint-disable react/no-danger, react/no-unescaped-entities, max-len, no-shadow */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-scroll';
import track from 'react-tracking';

import { ExpandCircleDown } from '@edx/paragon/icons';
import breakpoints from '@edx/paragon/dist/utils/breakpoints';

import classNames from 'classnames';
import getLinkProps from '@utils/reactScroll';
import { submitEvent } from '@utils/analytics';
import { FormattedMessage } from 'gatsby-plugin-react-intl';

export function BaseProgramDataBarButton(props) {
  const [isDesktopWindow, setIsDesktopWindow] = useState(false);
  const [focusOnEnroll, setFocusOnEnroll] = useState(false);

  const handleResize = () => {
    const isDesktopWindowRefresh = window.matchMedia(`(min-width: ${breakpoints.large.minWidth}px)`).matches;
    if (isDesktopWindow !== isDesktopWindowRefresh) {
      setIsDesktopWindow(isDesktopWindowRefresh);
    }
  };

  const getSkipLinkOffset = () => {
    if (isDesktopWindow) {
      return -350;
    }
    return -430;
  };

  const handleInterestClick = () => {
    // Fire analytics
    const componentProps = {
      category: 'navigation',
    };

    const { tracking } = props;
    submitEvent(
      tracking,
      componentProps,
      'edx.bi.experiment.i-am-interested.clicked',
    );
    // Move focus
    setFocusOnEnroll(true);
  };

  const getInterestFocusId = () => {
    const {
      enrollButtonId,
      enrollFocus,
      courseFocusId,
    } = props;
    return enrollFocus ? enrollButtonId : courseFocusId;
  };

  const linkProps = getLinkProps(() => { }, getSkipLinkOffset());
  const interestFocusId = getInterestFocusId();

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const interestFocusId = getInterestFocusId();
    if (focusOnEnroll) {
      window.document.getElementById(interestFocusId)?.focus();
      // eslint-disable-next-line react/no-did-update-set-state
      setFocusOnEnroll(false);
    }
  }, [focusOnEnroll]);

  const {
    isSubscriptionEnabled,
  } = props;

  const getButtonState = () => {
    if (isSubscriptionEnabled) {
      return (
        <>
          <FormattedMessage
            id="prospectus.program.subscription.data.bar.button.label"
            defaultMessage="Learn more"
            description="Label to scroll down to the subscription section."
          />
          <ExpandCircleDown fill="white" className="ml-2 text-white" />
        </>
      );
    }
    return (
      <>
        <FormattedMessage
          id="prospectus.programDataBar.skiplink.program.enroll"
          defaultMessage="I'm interested"
          description="Label for skip link to move to the program enroll section of the page."
        />
        <ExpandCircleDown className="ml-2" />
      </>
    );
  };

  return (
    <Link
      {...linkProps}
      to={interestFocusId}
      href={`#${interestFocusId}`}
      onClick={() => handleInterestClick()}
      className={classNames(
        'font-weight-bold',
        'd-flex',
        'align-items-center',
        { 'btn-of-subscription': isSubscriptionEnabled },
        { 'btn-of-interest': !isSubscriptionEnabled },
        { 'bg-white': !isSubscriptionEnabled },
        { 'w-full': !isSubscriptionEnabled },
        { 'color-sapphire': !isSubscriptionEnabled },
      )}
    >
      {getButtonState()}
    </Link>
  );
}

BaseProgramDataBarButton.propTypes = {
  enrollButtonId: PropTypes.string.isRequired,
  courseFocusId: PropTypes.string,
  enrollFocus: PropTypes.bool,
  tracking: PropTypes.shape().isRequired,
  isSubscriptionEnabled: PropTypes.bool,
};

BaseProgramDataBarButton.defaultProps = {
  courseFocusId: '',
  enrollFocus: true,
  isSubscriptionEnabled: false,
};

export default track({
  component: 'program-data-bar-button',
})(BaseProgramDataBarButton);
